module.exports = __webpack_public_path__ + "static/media/zameen360.55220cb6.jpg";